$ = jQuery;
export const menu = {
  init: function () {
    $(".menu-mobile").on("click", function () {
      if ($("body").hasClass("menu-opened")) {
        $("body").addClass("closing");
        setTimeout(function () {
          $("body").removeClass("closing");
          $("body").removeClass("menu-opened");
        }, 750);
      } else {
        $("body").addClass("menu-opened");
      }
    });
    $("ul.main a, .anchor a").on("click", function (e) {
      e.preventDefault();
      var target = $(this).attr("href");
      var pad = window.innerWidth < 1025 ? 80 : 120;
      var top = $(target).offset().top - pad;
      $("body").addClass("closing");
      $("ul.main a").addClass("lock").removeClass("open");
      $(this).addClass("open");
      setTimeout(function () {
        $("body").removeClass("closing");
        $("body").removeClass("menu-opened");
      }, 750);
      setTimeout(function () {
        $("ul.main a").removeClass("lock").removeClass("open");
      }, 1500);
      $("html,body").animate(
        {
          scrollTop: top,
        },
        1500,
        "easeInOutQuint"
      );
      return false;
    });
  },
};
